import { Col, Text } from 'components';
import { capitalize, formatLocale, theme } from 'lib';
import { memo } from 'react';
import { TableComponents } from 'screens/Admin/components';

const ListItem = memo(({ item, onClick = null, dataId }) => {
  const isSelected = dataId === item._id,
    { owner, ownerType, recent, updatedAt } = item;

  return (
    <TableComponents.Tr onClick={() => onClick(item._id)} isSelected={isSelected}>
      <TableComponents.Td isSelected={isSelected} first>
        <Text>{owner?.name}</Text>
        <Text c1 col={theme.GREY_60}>
          @{owner?.username}
        </Text>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text>{capitalize(owner?.type)}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected} last>
        <Col noFlex>
          <Text>
            {item.createdAt ? formatLocale(new Date(item.createdAt), 'LLL do yyy, hh:mm a') : ''}
          </Text>
        </Col>
      </TableComponents.Td>
    </TableComponents.Tr>
  );
});

export default ListItem;
